<template>
  <div class="login min-vh-100 d-flex justify-content-center align-items-center p-3">
    <b-overlay rounded opacity="0.1" spinner-variant="light" class="w-100 login-overlay">
      <b-card header-bg-variant="azul" class="contenido-card mx-auto shadow-lg">
        <b-card-body class="d-flex flex-column justify-content-between p-3 p-sm-4 p-lg-5">
          
          <!-- Header / Logo -->
          <div class="text-center my-2 my-md-3">
            <div class="contenido-logo mb-2 mb-md-3">
              <img :src="aciquiLogo" :class="['login-logo', { 'logo-active': isMounted }]" alt="Logo ACIQUI">
            </div>
            <div class="text-center text-white version-text">
              <span>{{ version }}</span>
            </div>
          </div>

          <!-- Formulario / Pasos -->
          <div class="my-3 my-md-4">
            <b-form v-if="step === 'usuario'" :class="mensajeError ? 'mt-3' : 'mt-1'" @submit="onSubmit" ref="form" lazy-validation>
              <div v-if="mensajeError">
                <b-alert class="mensaje-error text-center" show variant="danger">{{ mensajeError }}</b-alert>
              </div>
              <b-form-group class="mb-3 mb-md-4">
                <b-form-input
                  id="txt-username"
                  class="form-input"
                  type="text"
                  placeholder="Usuario"
                  v-model="usuario.username"
                  required
                  autofocus
                ></b-form-input>
                <b-form-invalid-feedback id="txt-username-invalid">Ingrese el nombre de usuario</b-form-invalid-feedback>
              </b-form-group>
              <b-button
                class="btn-login w-100"
                type="submit"
                variant="info"
                @click="continuar"
                size="lg"
                :disabled="busy"
                block
              >CONTINUAR</b-button>
            </b-form>

            <login-password-step
              v-else
              :username="usuario.username"
              :nombre-completo="usuarioNombreCompleto"
              :grupo="usuarioGrupo"
              :ultima-conexion="usuarioUltimaConexion"
              :servidor-inicial="usuario.servidor"
              :mensaje-error="mensajeError"
              :busy="busy"
              @submit="onPasswordStepSubmit"
              @volver="volverAUsuario"
            />
          </div>

          <!-- Footer Info -->
          <div class="text-center mt-3 mt-md-4">
            <span class="navegador d-block">
              Navegador mínimo recomendado Chrome 94
            </span>
            <span class="navegador d-block mt-1">
              Su navegador actual es: {{ navegador }}
            </span>
          </div>

        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import sesion from "../../controllers/LoginController";
import { mapState } from "vuex";

const imgLink = require("../../assets/images/brujula2.jpeg");
import logo from "@/assets/images/logoACIQUI.svg";
import aciquiLogo from "@/assets/images/aciqui_logo.svg";
import UsersDataService from "../../services/UsersDataService";
import App from "../../App.vue";
import AccionesDataService from "../../services/AccionesDataService";
/** Capacitor Device API para obtener datos del dispositivo */
import { Device } from "@capacitor/device";
/** Obtiene información relevante del cliente. */

import { getToken } from "firebase/messaging";

import Crypto from "../../services/Crypto";
import { getServidorPorAmbiente, normalizeServidor, validarServidor } from "../../utils/Utils"
import LoginPasswordStep from "./LoginPasswordStep.vue";

const getDeviceInfo = async () => {
  /** Comunicador entre cliente y servidor. */
  const userAgent = navigator.userAgent;

  /** Id del dispositivo del cliente. */

  /** Sistema operativo del cliente. */
  const deviceInfo = await Device.getInfo();
  const deviceOs = JSON.stringify(deviceInfo.operatingSystem).slice(1, -1);

  /** Nombre del dispositivo del cliente. Solo usada para smartphones
   * Android superiores a 7.1 y en IOS superiores a 16.
   * Por ejemplo: "John's iPhone".
   */
  const deviceName =
    deviceOs === "windows" || deviceOs === "mac"
      ? ""
      : JSON.stringify(deviceInfo.name);

  /** El dispostivo se encuentra emulado o virtualizado ? */

  /**
   * Función encargada de retornar el navegador y la versión con la cual
   * se está accediendo al link del dispositivo compartido.
   */
  function obtenerNavegador() {
    const browsers = {
      Firefox: /Firefox\/([0-9.]+)/,
      Chrome: /Chrome\/([0-9.]+)/,
      Safari: /Version\/([0-9.]+).*Safari/,
      Edge: /Edge\/([0-9.]+)/,
      Opera: /(Opera|OPR)\/([0-9.]+)/,
      "Internet Explorer": /(Trident\/.*rv:|MSIE )([0-9.]+)/,
    };

    for (const browser in browsers) {
      const match = userAgent.match(browsers[browser]);
      if (match && match.length > 1) {
        return `${browser}/${match[1]}`;
      }
    }
    return "Navegador desconocido";
  }

  /**
   * Funcion encargada de obtener la información del dispositivo tal como:
   * S.O, versión y modelo.
   */
  function obtenerInfoDispositivo() {
    let deviceName = "Equipo desconocido";
    const computerMatches = userAgent.match(/\(([^)]+)\)/);
    if (computerMatches && computerMatches.length > 1) {
      deviceName = computerMatches[1];
    }
    return deviceName;
  }

  /**  Direccion ip pública del dispositivo que accede al enlace. */
  let ipAddress;
  const axios = require("axios");
  try {
    const { data } = await axios.get("https://api.ipify.org?format=json");
    ipAddress = data.ip;
  } catch (error) {
    console.error("Error al obtener la infor del dispositivo: ", error)
    ipAddress = "Ip desconocida";
  }

  /** Almacena el navegador previamente obtenido. */
  const navegador = obtenerNavegador();
  /** Almacena la informacion relevante del dispositvo previamente obtenida. */
  const infoDevice = obtenerInfoDispositivo();

  /** Accion para la bitacora Modificar texto*/
  let accion = ` desde aplicación web a través el navegador ${navegador}, con la dirección IP ${ipAddress} a través del dispositivo ${deviceName} ${infoDevice}`;
  const logDevice = `${infoDevice},${ipAddress},${navegador}`;
  sessionStorage.setItem('logDevice', logDevice);
  sessionStorage.setItem("infoDevice", accion);
};
getDeviceInfo();

export default {
  name: "FullLogin",
  mixins: [validationMixin],
  components: {
    LoginPasswordStep,
  },
  data: () => ({
    img: imgLink,
    logo: logo,
    aciquiLogo: aciquiLogo,
    step: "usuario",
    usuarioNombreCompleto: "",
    usuarioGrupo: null,
    usuarioUltimaConexion: null,
    form: {
      username: "",
      pwd: "",
    },
    contador: 1,
    checkbox: false,
    usuario: {
      username: "",
      password: "",
      nombre: "",
      id: "",
      rol: "",
      servidor: "",
    },
    busy: false,
    timeout: null,
    error: false,
    mensajeError: "",
    accion: "",
    version: sesion.version(),
    navegador: sesion.navegador(),
    k: process.env.VUE_APP_P,
    isMounted: false,
  }),
  beforeDestroy() {
    this.clearTimeout();
  },
  computed: {
    ...mapState(["navbarColor", "logoColor", "Sidebar_drawer", "SidebarColor"]),
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(4),
      },
      pwd: {
        required,
        minLength: minLength(6),
      },
      servidor: {
        required,
        minLength: minLength(6),
      },
    },
  },

  beforeCreate() {
    const instancia = localStorage.getItem("aciqui_instance");

    const servidor = getServidorPorAmbiente();
    

    if (instancia === null || instancia === undefined) {

      const url = `${servidor}/api/auth/eliminar-token`;
      const data = {
        token: localStorage.getItem("tokenSesion"),
        tokenPush: localStorage.getItem("tokenPush"),
      }

      fetch(url, {
        keepalive: true,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Aurorization": `Bearer ${data.token}`,

        },
        body: JSON.stringify(data),
      })
    }
  },

  mounted() {
    this.mostrarMensaje(this.$route.params);

    this.obtenerTokenPushNotificaciones()

    this.$nextTick(() => {
      this.usuario.servidor = localStorage.getItem("servidor");
      localStorage.removeItem('publicKey');
      this.isMounted = true;
    });
  },

  methods: {

    /**
     * Método para obtener el token de las notificaciones push
     */
    /*obtenerTokenPushNotificaciones() {
      getToken(this.$messaging,
        { vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY })
        .then((currentToken) => {
          if (currentToken) {
            localStorage.setItem('tokenPush', currentToken)
          }
        }).catch((err) => {
          console.log('Error catch ', err);
        });
    },*/

    async obtenerTokenPushNotificaciones() {
      try {
        // 1. Verificar soporte y registrar el Service Worker de forma explícita
        if ('serviceWorker' in navigator) {
          const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

          // 2. Solicitar el token pasando el registro del Service Worker
          const currentToken = await getToken(this.$messaging, {
            vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration
          });

          if (currentToken) {
            localStorage.setItem('tokenPush', currentToken);
          }
        }
      } catch (err) {
        console.error('Error al obtener token Push en Login:', err);
      }
    },

    mostrarMensaje(datos) {
      if (datos.mensaje) {
        // Si el bloqueo de "sistema en uso" está activo (main.js), no mostrar
        // este toast: pisaría el modal bloqueante de SweetAlert2 (solo puede
        // haber un popup activo a la vez) y dejaría ver el login indebidamente.
        const sistemaEnUso =
          localStorage.getItem("aciqui_instance") &&
          !localStorage.getItem("esCompartirLink") &&
          !sessionStorage.getItem("token");
        if (sistemaEnUso) {
          return;
        }

        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "warning",
          title: datos.mensaje,
        });
      }
    },
    onSubmit(event) {
      event.preventDefault();
    },

    /**
     * Primer paso del login: valida que el usuario ingresado exista antes de
     * mostrar el componente que solicita contraseña y servidor.
     */
    async continuar() {
      this.mensajeError = "";

      if (!this.usuario.username || !this.usuario.username.trim()) {
        this.mensajeError = "Ingrese el nombre de usuario";
        return;
      }

      try {
        this.busy = true;
        const { data } = await sesion.existeUsuario(this.usuario.username);
        if (!data.existe) {
          this.mensajeError = "Usuario no encontrado";
          return;
        }
        this.usuarioNombreCompleto = data.nombreCompleto;
        this.usuarioGrupo = data.grupo;
        this.usuarioUltimaConexion = data.ultimaConexion;
        this.step = "credenciales";
      } catch (error) {
        console.error("Error al verificar el usuario: ", error);
        this.mensajeError = "Usuario no encontrado";
      } finally {
        this.busy = false;
      }
    },

    volverAUsuario() {
      this.step = "usuario";
      this.mensajeError = "";
      this.usuario.password = "";
      this.usuarioNombreCompleto = "";
      this.usuarioGrupo = null;
      this.usuarioUltimaConexion = null;
    },

    onPasswordStepSubmit({ password, servidor }) {
      this.usuario.password = password;
      this.usuario.servidor = servidor;
      this.login();
    },

    validateState(username) {
      const { $dirty, $error } = this.$v.form[username];
      return $dirty ? !$error : null;
    },
    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    validar() {
      if (this.usuario.username === "") {
        this.mensajeError = "Ingrese el nombre del usuario";
      } else if (this.usuario.password === "") {
        this.mensajeError = "Ingrese la contraseña";
      } else if (this.usuario.servidor === "") {
        this.mensajeError = "Ingrese el servidor local";
      } else {
        localStorage.setItem("servidor", this.usuario.servidor);
      }
    },


    async login() {
      const validacionServidor = validarServidor(this.usuario.servidor);
      if (!validacionServidor.valido) {
        this.mensajeError = validacionServidor.mensaje;
        return;
      }

      try {
        this.busy = true;
        const userData = await this.prepareUserData();
        await this.authenticate(userData);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.busy = false;
      }
    },

    async prepareUserData() {
      return {
        username: this.usuario.username,
        password: this.usuario.password,
        nombre: this.usuario.nombre,
        rol: this.usuario?.rol ? this.usuario.rol.role : "",
        servidor: normalizeServidor(this.usuario.servidor),
        sistemaOperativo: "web",
      };
    },

    async authenticate(userData) {
      sessionStorage.setItem("sistemaOperativo", "web");
      const infoDevice = sessionStorage.getItem("infoDevice");
      const response = await sesion.login(userData, this.k, infoDevice);

      const decoded = await Crypto.desencriptar(
        response.data.aesData,
        response.data.key
      );

      this.storeSessionData(decoded, userData);
    },

    storeSessionData(decoded, userData) {
      sessionStorage.setItem("token", decoded.token);
      localStorage.setItem("tokenSesion", decoded.token);
      localStorage.setItem("aciqui_instance", "true");
      sessionStorage.setItem("username", decoded.username);
      sessionStorage.setItem("id_user", decoded.id_user);
      sessionStorage.setItem("email", decoded.email);
      sessionStorage.setItem("rol", decoded.rol);
      sessionStorage.setItem("banConfig", "false");
      sessionStorage.setItem("banMonitoreo", "false");
      sessionStorage.setItem("socket", false);
      sessionStorage.setItem("idRol", decoded.idRol);
      sessionStorage.setItem("areaUser", decoded.area.id);
      sessionStorage.setItem("nombreUsuario", "null");
      sessionStorage.setItem(
        "ubicacionTiempoReal",
        decoded.habilitarTiempoReal
      );
      sessionStorage.setItem('key', decoded.key);
      localStorage.setItem("servidor", userData.servidor);
      if (sessionStorage.idRol === process.env.VUE_APP_ID_MASTER) {
        sessionStorage.setItem("usuarioFiltro", "");
      }
      if (decoded.extra == "1") {
        this.handlePasswordReset(decoded);
      } else if (decoded.extra === "0") {
        this.handleSuccessfulAuthentication();
      }
      App.methods.cambiar();
    },

    handlePasswordReset(decoded) {
      this.$router.push({
        name: "Restablecer contrasena",
        params: {
          username: decoded.username,
          contrasena: decoded.contrasena,
          contrasenaTemporal: decoded.temporal,
        },
      });
    },

    handleSuccessfulAuthentication() {
      this.registrarAccion();
      this.$router.push("/monitoreo");
    },

    handleError(error) {
      try {
        this.error = true;

        // Mapeo de errores. El usuario ya fue validado en el primer paso del
        // login, por lo que aquí el error solo puede deberse a la contraseña
        // o al servidor.
        const mensajesError = {
          401: "Contraseña o servidor incorrecto", // Unauthorized
          403: "Contraseña o servidor incorrecto", // Forbidden
          404: "Usuario deshabilitado comuníquese con un administrador",
          409: error.response.data?.mensaje || "Esta cuenta ya tiene una sesión activa.", // Conflict
        };

        //Determina el tipo de estatus
        const estatus = error.response.status;
        this.mensajeError = mensajesError[estatus] || "Error desconocido";
      } catch (error) {
        console.warn("Contraseña o servidor incorrecto: ", error)
        this.mensajeError = "Contraseña o servidor incorrecto";
      }
    },

    /**
     * Método para registrar acciones en base al usuario logueado
     */
    registrarAccion() {
      const key = sessionStorage.getItem('key');
      UsersDataService.getUsuario(key).then(async (response) => {
        const decoded = await Crypto.desencriptar(response.data, key);

        const data = {
          usuario: decoded,
          accion: "Inicio de sesión" + sessionStorage.infoDevice,
          fechaCreacion: new Date(),
          tipo: "accion",
        };
        sessionStorage.setItem("usuarioLogueado", JSON.stringify(decoded)); //se almacena el usuario en la sesion activa
        AccionesDataService.create(data, key);
      });
    },
  },
};
</script>

<style scoped>
.login {
  min-height: 100vh;
  width: 100%;
  background: radial-gradient(circle at 75% -50%, #00000090 30%, #ffffff00 40%),
    linear-gradient(-40deg, #ff000000, #080c34 60%, #0000ff00),
    radial-gradient(circle at 55% 150%, #3094bc 40%, #00000010 70%),
    radial-gradient(at 0% 0%, #206ca4 5%, #00000000 40%),
    linear-gradient(to bottom, #080c34 0%, #184c7c 100%);
}

.contenido-card {
  position: relative;
  width: clamp(280px, 92vw, 460px);
  border-radius: 0.625rem;
  /* Fondo original intacto en toda la tarjeta */
  background: linear-gradient(to bottom, #324D6F 0%, transparent 100%);
  border: none;
}

/* Pseudoelemento para dibujar únicamente el borde que se difumina en la base */
.contenido-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0.625rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  pointer-events: none;
  
  /* Se degrada SOLAMENTE el borde de abajo hasta desaparecer a cero opacidad */
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0) 100%);
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0) 100%);
}

.contenido-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-logo {
  width: clamp(5.5rem, 18vw, 8.5rem);
  height: auto;
}

.version-text {
  font-size: clamp(0.8rem, 1.2vw, 0.95rem);
}

.navegador {
  color: rgba(255, 255, 255, 0.85);
  font-size: clamp(0.75rem, 1.1vw, 0.88rem);
  font-weight: 300;
}

/* Estilos globales para inputs y botones (incluye componentes hijos) */
::v-deep .form-input,
::v-deep .form-input:focus,
::v-deep input[type="text"],
::v-deep input[type="password"] {
  border-radius: 1.25rem;
  background-color: #324D6F;
  color: white;
  height: clamp(2.8rem, 5vh, 3.5rem);
  font-size: clamp(0.9rem, 1.5vw, 1.05rem);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

::v-deep .form-input::placeholder {
  color: rgba(255, 255, 255, 0.65);
}

::v-deep .btn-login,
::v-deep button[type="submit"] {
  background-color: #2471a3;
  border-color: #2471a3;
  color: white;
  border-radius: 1.25rem;
  height: clamp(3rem, 5.5vh, 3.8rem);
  font-size: clamp(0.95rem, 1.6vw, 1.15rem);
  font-weight: 600;
}

/* Escala para Monitores Ultrawide / 2K / 4K */
@media (min-width: 2000px) {
  .contenido-card {
    width: clamp(550px, 35vw, 750px);
    border-radius: 1.5rem;
  }

  .contenido-card::after {
    border-radius: 1.5rem;
  }

  .login-logo {
    width: 12rem;
  }

  .navegador,
  .version-text {
    font-size: 1.2rem;
  }

  ::v-deep .form-input,
  ::v-deep .form-input:focus,
  ::v-deep input[type="text"],
  ::v-deep input[type="password"] {
    height: 4.2rem;
    font-size: 1.4rem;
    border-radius: 2rem;
  }

  ::v-deep .btn-login,
  ::v-deep button[type="submit"] {
    height: 4.5rem;
    font-size: 1.5rem;
    border-radius: 2rem;
  }
}
</style>